module.exports = __webpack_public_path__ + "static/media/ace.c2187385.svg";